<template>
    <modal name="update_location" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update location')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <app-multi-lang-input id="name"
                                          v-model="form.name"
                                          name="name"
                                          rules="required"
                                          :langs="locales && Object.keys(locales)">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-multi-lang-input>
                    <app-checkbox id="main_location" v-model="form.main_location" name="main_location">
                        {{ $t('Main location') }}
                    </app-checkbox>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import LocationService from '@services/location.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            loading: false,
            location_id: null
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    LocationService.update(this.location_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setLocation', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const location = event.params.location;
            if (location) {
                this.form.name = Object.assign({}, location.name);
                this.form.main_location = location.main_location;
                this.location_id = location.id;
            }
        },
        hide() {
            this.$modal.hide('update_location');
        }
    }
};
</script>
